import RNMsgChannel from 'react-native-webview-messaging';
import apiService from '../../services/ApiService';

const reactNativeBridge = {
    initRecordingHandler: undefined,
    endRecording: undefined,
    isRecording: false,
    currentData: '',

    isNewApp: true,
    isIOSRecorderEnabled: false, // to be removed from code
    isAudioTool: true,
    isInitialized: false,
    timerVar: undefined,
    checkTimer: undefined,

    init(initRecordingHandler) {
        this.initRecordingHandler = initRecordingHandler;

        setTimeout(this.initProperties.bind(this), 3000);

        RNMsgChannel.on('text', this.onCheckAppType.bind(this));
        RNMsgChannel.send('IsRecordingEnabled');
    },
    onCheckAppType(e) {
        if (e == 'IsRecordingEnabled' || e == 'IsRecordingDisabled')
            this.isNewApp = false;
    },
    initProperties() {
        if (!this.isNewApp) {
            this.checkProperties();
        } else { // it's stage ... the new app
            if (this.initRecordingHandler)
                this.initRecordingHandler();

            window.addEventListener('message', this.getMessageFromRN.bind(this));
        }
    },
    sendMessageToRN(message) {
        if (!this.isNewApp)
            RNMsgChannel.send(message);
        else {
            window.ReactNativeWebView.postMessage(message);
        }
    },
    startRecording() {
        this.isRecording = true;
        this.sendMessageToRN('StartRecording');
    },
    stopRecording(endRecording) {
        this.endRecording = endRecording;
        this.isRecording = false;
        this.sendMessageToRN('StopRecording');
    },
    getMessageFromRN(e) {
        var message = e.data;

        if (message == 'StartRecordingAvailable') { // start recording:
            if (!this.isRecording && this.endRecording)
                this.endRecording(undefined);
        } else if (message.length > 50) { // stopped recording: received blob content encoded as base64 chunks
            this.getBase64Chunks(message);
        }
    },
    getBase64Chunks(data) {
        if (data.indexOf('all:') != -1) {
            this.currentData = data.slice(4);
            this.onRecordedBlobReceivedFromRN(this.currentData);
        } else
        if (data.indexOf('start:') != -1) {
            this.currentData = data.slice(6);
            this.sendMessageToRN('SendData');
        } else
        if (data.indexOf('end:') != -1) {
            this.currentData = this.currentData + data.slice(4);
            this.onRecordedBlobReceivedFromRN(this.currentData);
        } else { // is middle:
            this.currentData = this.currentData + data.slice(7);
            this.sendMessageToRN('SendData');
        }
    },
    onRecordedBlobReceivedFromRN(base64Content) {
        var useFetch = true;

        if (useFetch)
            this.base64DataToBlobWithFetch(base64Content);
        else {
            var blob = this.base64DataToBlob(base64Content);

            if (this.endRecording && blob)
                this.endRecording(blob);
        }
    },
    base64DataToBlobWithFetch(data) {
        apiService.getBlobFromBase64Url(data).then(blob => {
            if (this.endRecording && blob)
                this.endRecording(blob);
        });
    },
    base64DataToBlob(data) {
        var binaryData = this.convertDataURIToBinary(data);
        var blob = new Blob([binaryData], {type : 'audio/wav'});

        return blob;
    },
    convertDataURIToBinary(dataURI) {
        var BASE64_MARKER = ';base64,';
        var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
        var base64 = dataURI.substring(base64Index);
        var raw = window.atob(base64);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for(var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }

        return array;
    },
    addAlert(text) {
        var element = document.getElementById('alertHolder');

        if (element && element.parentNode)
            element.parentNode.removeChild(element);

        var dateSpan = document.createElement('div');
        dateSpan.id = 'alertHolder';
        dateSpan.innerHTML = text;
        dateSpan.style.position = 'absolute';
        dateSpan.style.left = '0px';
        dateSpan.style.top = '0px';
        dateSpan.style.display = 'block';
        dateSpan.style.background = '#ff0000';

        document.body.appendChild(dateSpan);
    },


    checkProperties() {
        if (!this.isInitialized) {
            RNMsgChannel.on('text', this.onMessageReceivedFromRN.bind(this));
            RNMsgChannel.on('custom-event-from-rn', this.onDataMessageReceivedFromRN.bind(this));

            if (this.isAudioTool) {
                this.checkTimer = setTimeout(this.responseTimeExpired.bind(this), 6 * 1000);

                setTimeout(function() {
                    this.sendMessageToRN('IsRecordingEnabled');
                }.bind(this), 2 * 1000);
            } else
                this.sendMessageToRN('IsRecordingEnabled');
        } else {
            if (this.isIOSRecorderEnabled) {
                if (this.initRecordingHandler)
                    this.initRecordingHandler();
            } else {
                this.enableRecording();
            }
        }

        this.isInitialized = true;
    },
    onMessageReceivedFromRN(e) {
        var textData = e;

        // this.addAlert(textData + ' length === ' + textData.length);

        switch (textData) {
            case 'RecordingAvailable': {
                this.timerVar = setTimeout(this.initRecorder.bind(this), 5 * 1000);
                break;
            }

            case 'StartRecordingAvailable': {
                if (!this.isRecording && this.endRecording)
                    this.endRecording(undefined);
                break;
            }

            case 'IsRecordingEnabled': {
                this.isIOSRecorderEnabled = true;

                if (this.checkTimer)
                    clearTimeout(this.checkTimer);

                if (this.initRecordingHandler)
                    this.initRecordingHandler();
                break;
            }

            case 'IsRecordingDisabled': {
                if (this.checkTimer)
                    clearTimeout(this.checkTimer);

                this.enableRecording();
                break;
            }
        }
    },
    onDataMessageReceivedFromRN(data) {
        this.onRecordedBlobReceivedFromRN(data.content);
    },
    enableRecording() {
        this.sendMessageToRN('EnableRecording');
    },
    responseTimeExpired() {
        this.enableRecording();
    },
    initRecorder() {
        if (this.timerVar)
            clearTimeout(this.timerVar);

        if (this.initRecordingHandler)
            this.initRecordingHandler();
    }
};

export default reactNativeBridge;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ReactNativeBridge.js
 **/